import React, { useCallback } from "react";
import CrossIcon from "assets/icons/crossAccent.svg";
import { Modal } from "react-bootstrap";
import Button from "common/components/Button";

import "./styles.scss";
import { useTypedDispatch, useTypedSelector } from "store";
import { setTriggerAlert } from "store/users/slice";

const Alert = () => {
  const dispatch = useTypedDispatch();
  const { showAlert } = useTypedSelector((store) => store.user);
  const onHide = useCallback(() => {
    dispatch(
      setTriggerAlert({
        show: false
      })
    );
  }, [dispatch]);
  return (
    <Modal
      show={showAlert.show}
      onHide={onHide}
      backdrop="static"
      animation={false}
      keyboard={false}
      centered
      className="container-contact-modal">
      <div className="alert-global-wrapper">
        <div className="alert-global-fon"></div>
        <div className="container-global-wrapper">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              cursor: "pointer"
            }}
            onClick={onHide}>
            <img src={CrossIcon} style={{ width: 26, height: 26 }} />
          </div>
          <div style={{ paddingRight: 40, paddingLeft: 40 }}>
            <div
              style={{
                marginTop: 22,
                textAlign: "center"
              }}>
              <span
                style={{
                  color: "#6846B0",
                  fontSize: 40,
                  fontWeight: 700
                }}>
                אירעה שגיאה לא צפויה
              </span>
            </div>
            <Button
              typeBtn="red"
              text={"לחצו כאן"}
              style={{ marginTop: 20 }}
              onClick={() => location.reload()}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Alert;
